export default "__VITE_ASSET__B7KwWUmv__"